import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageFooterWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageFooter__PrimaryMessageFooterWrapper"
})(["display:flex;margin-top:4px;max-width:284px;"]);
// max-width is for IE (376px-92px)

export default class PrimaryMessageFooter extends PureComponent {
  render() {
    const {
      children,
      className
    } = this.props;
    return /*#__PURE__*/_jsx(PrimaryMessageFooterWrapper, {
      "data-test-id": "primary-message-footer",
      className: className,
      children: children
    });
  }
}
PrimaryMessageFooter.displayName = 'PrimaryMessageFooter';
PrimaryMessageFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};